import { useTheme } from '@mui/material';

export const ErrorIcon500 = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
        background: { primary: primaryBackground },
    } = theme.colors.other.icon;

    return (
        <svg
            width="376"
            height="172"
            viewBox="0 0 376 172"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M87.8155 141.193C87.3591 134.804 86.4869 125.617 86.1006 121.749C86.0958 121.7 86.0877 121.655 86.076 121.608L82.9605 109.146C82.8027 108.515 83.2801 107.904 83.9307 107.904H114.472C114.981 107.904 115.408 108.286 115.465 108.792L120.401 152.668C120.47 153.275 119.983 153.801 119.373 153.78L88.9541 152.712C88.3507 152.691 87.8942 152.143 87.9424 151.541C88.0888 149.715 88.1752 146.229 87.8155 141.193Z"
                fill={primaryBackground}
            />
            <path
                d="M199.737 35.5853C200.179 34.7015 193.923 14.2562 190.382 2.99886C190.181 2.35995 190.654 1.71201 191.324 1.70221L306.804 0.012253C307.288 0.0051631 307.708 0.346417 307.8 0.82212L314.3 34.4073C314.419 35.0203 313.977 35.5908 313.352 35.5969C274.531 35.9786 199.283 36.4943 199.737 35.5853Z"
                fill={primaryBackground}
            />
            <path
                d="M15.5096 135.153L24.8742 112.017C25.1806 111.26 26.2162 111.17 26.6491 111.862L40.4205 133.897C40.8256 134.545 40.3835 135.389 39.6201 135.426L16.4841 136.527C15.7552 136.562 15.2358 135.83 15.5096 135.153Z"
                fill={primaryBackground}
            />
            <path
                d="M348.404 58.2431L357.769 35.1071C358.075 34.35 359.111 34.2597 359.544 34.9523L373.315 56.9865C373.72 57.6346 373.278 58.4791 372.515 58.5154L349.379 59.6171C348.65 59.6518 348.13 58.9195 348.404 58.2431Z"
                fill={primaryBackground}
            />
            <path
                d="M94.4144 58.2432L92.2065 10.3312L97.3736 56.4159C97.487 57.4279 98.3428 58.193 99.3611 58.193H306.03C307.204 58.193 308.126 57.1862 308.022 56.0165L304.357 14.6514C304.266 13.6288 303.416 12.8408 302.389 12.8281L101.017 10.3312H305.157C306.226 10.3312 307.106 11.1715 307.155 12.2391L309.266 58.059C309.319 59.1985 308.409 60.1511 307.268 60.1511H96.4123C95.3436 60.1511 94.4636 59.3108 94.4144 58.2432Z"
                fill={primaryStroke}
            />
            <path
                d="M94.4144 113.343L92.2065 65.431L97.3736 111.516C97.487 112.528 98.3428 113.293 99.3611 113.293H306.03C307.204 113.293 308.126 112.286 308.022 111.116L304.357 69.7512C304.266 68.7286 303.416 67.9406 302.389 67.9279L101.017 65.431H305.157C306.226 65.431 307.106 66.2713 307.155 67.3389L309.266 113.159C309.319 114.298 308.409 115.251 307.268 115.251H96.4123C95.3436 115.251 94.4636 114.411 94.4144 113.343Z"
                fill={primaryStroke}
            />
            <path
                d="M94.4144 169.591L92.2065 121.679L97.3736 167.763C97.487 168.775 98.3428 169.541 99.3611 169.541H306.03C307.204 169.541 308.126 168.534 308.022 167.364L304.357 125.999C304.266 124.976 303.416 124.188 302.389 124.176L101.017 121.679H305.157C306.226 121.679 307.106 122.519 307.155 123.587L309.266 169.407C309.319 170.546 308.409 171.499 307.268 171.499H96.4123C95.3436 171.499 94.4636 170.658 94.4144 169.591Z"
                fill={primaryStroke}
            />
            <ellipse
                cx="111.921"
                cy="35.3805"
                rx="4.01769"
                ry="5.16561"
                transform="rotate(-10.0305 111.921 35.3805)"
                fill={primaryStroke}
            />
            <ellipse
                cx="111.921"
                cy="90.4803"
                rx="4.01769"
                ry="5.16561"
                transform="rotate(-10.0305 111.921 90.4803)"
                fill={primaryStroke}
            />
            <ellipse
                cx="111.921"
                cy="146.728"
                rx="4.01769"
                ry="5.16561"
                transform="rotate(-10.0305 111.921 146.728)"
                fill={primaryStroke}
            />
            <ellipse
                cx="125.387"
                cy="35.3805"
                rx="4.01769"
                ry="5.16561"
                transform="rotate(-10.0305 125.387 35.3805)"
                fill={primaryStroke}
            />
            <ellipse
                cx="125.387"
                cy="146.728"
                rx="4.01769"
                ry="5.16561"
                transform="rotate(-10.0305 125.387 146.728)"
                fill={primaryStroke}
            />
            <ellipse
                cx="138.014"
                cy="35.3805"
                rx="4.01769"
                ry="5.16561"
                transform="rotate(-10.0305 138.014 35.3805)"
                fill={primaryStroke}
            />
            <path
                d="M250.82 24.1062C250.437 30.9936 249.901 44.9982 250.82 45.9165C251.738 46.8348 251.202 31.7589 250.82 24.1062Z"
                fill={primaryStroke}
            />
            <path
                d="M250.82 79.206C250.437 86.0934 249.901 100.098 250.82 101.016C251.738 101.935 251.202 86.8587 250.82 79.206Z"
                fill={primaryStroke}
            />
            <path
                d="M250.82 135.454C250.437 142.341 249.901 156.346 250.82 157.264C251.738 158.182 251.202 143.106 250.82 135.454Z"
                fill={primaryStroke}
            />
            <path
                d="M259.936 24.1062C259.553 30.9936 259.017 44.9982 259.936 45.9165C260.854 46.8348 260.318 31.7589 259.936 24.1062Z"
                fill={primaryStroke}
            />
            <path
                d="M259.936 79.206C259.553 86.0934 259.017 100.098 259.936 101.016C260.854 101.935 260.318 86.8587 259.936 79.206Z"
                fill={primaryStroke}
            />
            <path
                d="M259.936 135.454C259.553 142.341 259.017 156.346 259.936 157.264C260.854 158.182 260.318 143.106 259.936 135.454Z"
                fill={primaryStroke}
            />
            <path
                d="M269.052 24.1062C268.669 30.9936 268.134 44.9982 269.052 45.9165C269.97 46.8348 269.435 31.7589 269.052 24.1062Z"
                fill={primaryStroke}
            />
            <path
                d="M269.052 79.206C268.669 86.0934 268.134 100.098 269.052 101.016C269.97 101.935 269.435 86.8587 269.052 79.206Z"
                fill={primaryStroke}
            />
            <path
                d="M269.052 135.454C268.669 142.341 268.134 156.346 269.052 157.264C269.97 158.182 269.435 143.106 269.052 135.454Z"
                fill={primaryStroke}
            />
            <path
                d="M278.168 24.1062C277.785 30.9936 277.249 44.9982 278.168 45.9165C279.086 46.8348 278.55 31.7589 278.168 24.1062Z"
                fill={primaryStroke}
            />
            <path
                d="M278.168 79.206C277.785 86.0934 277.249 100.098 278.168 101.016C279.086 101.935 278.55 86.8587 278.168 79.206Z"
                fill={primaryStroke}
            />
            <path
                d="M278.168 135.454C277.785 142.341 277.249 156.346 278.168 157.264C279.086 158.182 278.55 143.106 278.168 135.454Z"
                fill={primaryStroke}
            />
            <path
                d="M287.284 24.1062C286.901 30.9936 286.366 44.9982 287.284 45.9165C288.202 46.8348 287.667 31.7589 287.284 24.1062Z"
                fill={primaryStroke}
            />
            <path
                d="M287.284 79.206C286.901 86.0934 286.366 100.098 287.284 101.016C288.202 101.935 287.667 86.8587 287.284 79.206Z"
                fill={primaryStroke}
            />
            <path
                d="M287.284 135.454C286.901 142.341 286.366 156.346 287.284 157.264C288.202 158.182 287.667 143.106 287.284 135.454Z"
                fill={primaryStroke}
            />
            <path
                d="M86.6676 35.5853H54.8131M22.9585 104.46V35.5853H54.8131M54.8131 35.5853V92.407H90.6853M307.641 149.803H361.593V86.6674M361.593 60.2654V86.6674M306.493 86.6674H361.593"
                stroke={primaryStroke}
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeDasharray="3 3"
            />
            <path
                d="M36.8807 134.22L9.52813 135.249L35.6705 133.281C36.4174 133.225 36.8397 132.398 36.4471 131.76L23.6198 110.918C23.2179 110.265 22.2607 110.289 21.8916 110.961L9.68919 133.186L21.7149 107.379C22.0593 106.64 23.0959 106.601 23.494 107.313L37.7158 132.733C38.0807 133.385 37.6274 134.192 36.8807 134.22Z"
                fill={primaryStroke}
            />
            <path
                d="M22.2005 124.555L21.8184 117.296C21.8132 117.197 21.8217 117.097 21.8503 117.002C22.0779 116.246 22.6702 115.279 23.5324 116.573C24.1904 117.56 23.7091 121.356 23.1018 124.625C22.9962 125.194 22.2309 125.133 22.2005 124.555Z"
                fill={primaryStroke}
            />
            <path
                d="M22.3845 129.774C22.1028 129.492 21.9507 129.052 21.8753 128.665C21.8027 128.294 22.0193 127.918 22.3907 127.843C23.1518 127.691 23.5324 128.158 23.5324 128.626C23.5324 129.2 22.9585 130.348 22.3845 129.774Z"
                fill={primaryStroke}
            />
            <path
                d="M374.367 53.8663L347.014 54.8951L373.157 52.9272C373.904 52.871 374.326 52.0438 373.933 51.4059L361.106 30.564C360.704 29.9109 359.747 29.9347 359.378 30.6069L347.176 52.832L359.201 27.0249C359.546 26.2859 360.582 26.2475 360.98 26.9591L375.202 52.3787C375.567 53.0309 375.114 53.8382 374.367 53.8663Z"
                fill={primaryStroke}
            />
            <path
                d="M359.687 44.2012L359.305 36.9424C359.3 36.8432 359.308 36.7435 359.337 36.6483C359.564 35.892 360.157 34.9255 361.019 36.2188C361.677 37.2058 361.195 41.0018 360.588 44.2711C360.482 44.8397 359.717 44.7787 359.687 44.2012Z"
                fill={primaryStroke}
            />
            <path
                d="M359.871 49.4198C359.589 49.1381 359.437 48.698 359.362 48.3116C359.289 47.9398 359.506 47.5639 359.877 47.4896C360.638 47.3371 361.019 47.8045 361.019 48.2719C361.019 48.8458 360.445 49.9937 359.871 49.4198Z"
                fill={primaryStroke}
            />
        </svg>
    );
};
